export default "__VITE_ASSET__BVeAzQ4___"